// Multilingual routing config (mirrors backend DEFAULT_LANGUAGES).
// English is the x-default served at the root (no prefix); the rest are prefixed.
export const SUPPORTED_LANGS = ["en", "fr", "de", "sv", "ru", "ar", "nl", "es", "pt", "fi"];
export const LANG_PREFIXES = SUPPORTED_LANGS.filter((l) => l !== "en");
export const RTL_LANGS = new Set(["ar"]);
export const OG_LOCALE = {
  en: "en_IE", fr: "fr_FR", de: "de_DE", nl: "nl_NL", sv: "sv_SE",
  fi: "fi_FI", es: "es_ES", pt: "pt_PT", ru: "ru_RU", ar: "ar_AR",
};

// Extract the active language from a pathname's first segment.
export function langFromPath(pathname = "/") {
  const seg = pathname.split("/").filter(Boolean)[0];
  return LANG_PREFIXES.includes(seg) ? seg : "en";
}

// Strip any language prefix, returning the "bare" path (always starts with "/").
export function stripLang(pathname = "/") {
  const parts = pathname.split("/").filter(Boolean);
  if (LANG_PREFIXES.includes(parts[0])) parts.shift();
  return "/" + parts.join("/");
}

// Build a language-prefixed path. English => bare path.
export function withLang(path = "/", lang = "en") {
  const bare = path.startsWith("/") ? path : `/${path}`;
  if (!lang || lang === "en") return bare === "/" ? "/" : bare.replace(/\/$/, "");
  return bare === "/" ? `/${lang}` : `/${lang}${bare.replace(/\/$/, "")}`;
}
